










































import {Component, Vue, Watch} from 'vue-property-decorator';
import {GetterNames} from "@/constants/GetterNames";
import {MutationNames} from "@/constants/MutationNames";
import {RouteNames} from "@/constants/RouteNames";
import {ActionNames} from '@/constants/ActionNames';

@Component
export default class Header extends Vue {
  public loadingUserInformation: boolean = false;

  get fullName(): string {
    return this.$store.getters[GetterNames.FULL_NAME];
  }

  get email(): string {
    return this.$store.getters[GetterNames.EMAIL];
  }

  get isLoggedIn(): boolean {
    return this.$store.getters[GetterNames.IS_LOGGED_IN];
  }

  public doLogout() {
    this.$store.commit(MutationNames.LOG_OUT);
  }

  @Watch('isLoggedIn')
  public async onIsLoggedInChanged() {
    if (!this.isLoggedIn) {
      this.$router.push({
        name: RouteNames.LOGIN,
      });
    } else {
      if (!this.loadingUserInformation) {
        this.loadingUserInformation = true;

        await this.$store.dispatch(ActionNames.GET_USER_INFORMATION);

        this.loadingUserInformation = false;
      }
    }
  }

  public async mounted() {
    if (this.isLoggedIn && !this.loadingUserInformation && this.fullName === '' && this.email === '') {
      this.loadingUserInformation = true;

      await this.$store.dispatch(ActionNames.GET_USER_INFORMATION);

      this.loadingUserInformation = false;
    }
  }
}
